<div class="group/textarea h-full">
    <div
        class="relative mt-5 box-border flex h-full flex-wrap border-2 border-grey-400 transition-all group-hover/textarea:border-blue"
        [ngClass]="{
            'border-red': error(),
        }"
    >
        <label class="relative flex flex-grow flex-col justify-center">
            <span
                class="absolute -top-14 left-0 bg-white px-12 text-12 leading-27 text-black transition-all duration-300 group-hover/textarea:text-blue"
                [ngClass]="{
                    'text-red': error(),
                }"
            >
                {{ label() }}
            </span>
            <textarea
                class="h-full min-h-48 w-full px-16 pt-10 text-black outline-none lg:min-h-full"
                [ngClass]="greyPlaceholder() ? '' : 'placeholder:text-black'"
                [ngStyle]="{ height: defaultHeightValue() }"
                [placeholder]="placeholder()"
                [value]="value() ?? null"
                (input)="setValue($event)"
                (focus)="_onTouch?.(); focussed.set(true)"
                (blur)="focussed.set(false)"
            ></textarea>
        </label>
    </div>
    @if (error() && errorMsg()) {
        <div class="h-16">
            <p class="leading-16 relative text-12 text-red">
                {{ errorMsg() }}
            </p>
        </div>
    }
</div>
